import { useState } from "react";

export default function Reservation() {
  const [isMessageSent, setMessageSent] = useState(false);
  const [error, setError] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [dateError, setDateError] = useState(null); // Stanje za datum grešku

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Provjera za datum
    const dateInput = event.target.elements.date;
    const selectedDate = new Date(dateInput.value);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Resetiranje vremena na početak dana

    // Ako je datum prošao, prikaži grešku
    if (selectedDate < today) {
      setDateError("Ovaj datum je vec prošao.");
      return;
    }

    setDateError(null); // Resetiraj datum grešku

    const formData = new FormData(event.target);
    formData.append("access_key", "c73dd095-3d41-4fb1-8931-62f25ceac1a0");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        setMessageSent(true);
        setFormSubmitted(true); // Form successfully submitted, hide form and show thank you message
      } else {
        const errorMessage = await response.text();
        setError(
          errorMessage || "Došlo je do greške. Molimo da pokušate ponovo."
        );
      }
    } catch (err) {
      setError("Došlo je do greške. Molimo da pokušate ponovo.");
    }
  };

  const handleRetry = () => {
    setError(null);
    setMessageSent(false); // Reset form state to try again
    setFormSubmitted(false); // Reset form submitted state
  };

  const handleGoToHomePage = () => {
    window.location.href = "/"; // Redirect to homepage
  };

  return (
    <section className="reservation">
      <h2>Rezervacija</h2>

      {!formSubmitted && !error && !isMessageSent ? (
        <form onSubmit={handleSubmit} className="reservation-form" id="form">
          {/* API Key */}
          <input
            type="hidden"
            name="access_key"
            value="c73dd095-3d41-4fb1-8931-62f25ceac1a0"
          />
          <input type="hidden" name="subject" value="Nova Rezervacija" />

          {/* Name */}
          <label htmlFor="name">
            Ime i prezime <span>*</span>
          </label>
          <input
            type="text"
            name="Ime i Prezime"
            id="name"
            placeholder="Unesite ime i prezime"
            required
          />

          {/* Email */}
          <label htmlFor="email">
            Email <span>*</span>
          </label>
          <input
            type="email"
            name="Email"
            id="email"
            placeholder="primjer@gmail.com"
            required
          />

          {/* Phone */}
          <label htmlFor="phone">
            Broj mobitela <span>*</span>
          </label>
          <input
            type="tel"
            name="Broj mobitela"
            id="phone"
            placeholder="+385 1 234 5678"
            required
          />

          {/* Number of Adults */}
          <label htmlFor="adults">
            Broj odraslih <span>*</span>
          </label>
          <select name="Broj odraslih" id="adults" required>
            <option value="" disabled selected>
              Odaberite
            </option>
            {[...Array(4)].map((_, i) => (
              <option key={i} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>

          {/* Number of Children */}
          <label htmlFor="children">Broj djece</label>
          <select name="Broj djece" id="children">
            <option value="0" selected>
              0
            </option>
            {[...Array(5)].map((_, i) => (
              <option key={i} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>

          {/* Pets */}
          <label htmlFor="pets">Kućni ljubimci</label>
          <select name="Kućni ljubimci" id="pets" required>
            <option value="" disabled selected>
              Odaberite
            </option>
            <option value="Da">Da</option>
            <option value="Ne">Ne</option>
          </select>

          {/* Preferred Date */}
          <label htmlFor="date">
            Datum dolaska <span>*</span>
          </label>
          <input
            type="date"
            name="Datum dolaska"
            id="date"
            placeholder="dd.mm.yyyy"
            required
            min={new Date().toISOString().split("T")[0]} // Onemogući prošle datume
          />
          {dateError && <p className="error-message">{dateError}</p>}

          {/* Additional Requests */}
          <label htmlFor="requests">Dodatne želje</label>
          <textarea
            name="Dodatne želje"
            id="requests"
            placeholder="Napišite vaše dodatne zahtjeve ili komentare ovdje..."
          ></textarea>

          {/* Submit Button */}
          <input type="submit" value="Rezerviraj" className="submit-btn" />
        </form>
      ) : null}

      {/* Error Message */}
      {error && !formSubmitted && (
        <div className="error-box">
          <h3>
            <i className="fi fi-ss-exclamation"></i> Došlo je do pogreške!
          </h3>
          <p>Molimo da pokušate ponovo ili nas kontaktirajte!</p>
          <a href="/">
            {" "}
            <i className="fi fi-rs-phone-flip"></i>095 1234 567
          </a>
          <button onClick={handleRetry} className="retry-btn">
            Pokušaj ponovo
          </button>
        </div>
      )}

      {/* Thank you message */}
      {isMessageSent && (
        <div className="thank-you">
          <h3>
            <i className="fi fi-ss-check-circle"></i> Rezervacija poslana!
          </h3>
          <p>Kontaktirat ćemo vas uskoro kako bismo potvrdili rezervaciju!</p>
          <button onClick={handleGoToHomePage} className="go-to-home-btn">
            Vratite se na početnu
          </button>
        </div>
      )}
    </section>
  );
}
